const Resources = {
    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "<span class='slash'>/</span>",
        },
    ],

    log_productivity_table_headers: [
        {
            text:   'Date',
            value:  'date',
            report_value: 'date',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   '# of Assign',
            value:  'total_assignments',
            report_value: 'total_assignments',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Time Available',
            value:  'minutes_available_calc',
            report_value: 'minutes_available_calc',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Discharge Capabilities',
            value:  'discharge_capability_calc',
            report_value: 'discharge_capability_calc',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Discharges Completed',
            value:  'discharge_beds_count',
            report_value: 'discharge_beds_count',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Overtime',
            value:  'over_time_minutes',
            report_value: 'over_time_minutes',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Project Minutes',
            value:  'project_time',
            report_value: 'project_time',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Other Minutes',
            value:  'other_assignments',
            report_value: 'other_assignments',
            type:   '',
            show: true,
            order: 0,

        },
        { 
            text:   'Cath Lab Cases',
            value:  'cath_lab_cases',
            report_value: 'cath_lab_cases',
            type:   '',
            with_icon: true,
            show: true,
            order: 1,
        },
        { 
            text:   'Cath Lab Inbetween Case Cleaning',
            value:  'cath_lab_in_between',
            report_value: 'cath_lab_in_between',
            show: true,
            order: 2,
        },
        { 
            text:   'OR Inbetween Case Cleaning',
            value:  'or_in_between',
            report_value: 'or_in_between',
            show: true,
            order: 2,
        },
        { 
            text:   'Triagle Inbetween Case Cleaning',
            value:  'triagle_in_between',
            report_value: 'triagle_in_between',
            show: true,
            order: 3,
        },
        {
            text:   'ED Inbetween Case Cleaning',
            value:  'ed_in_between',
            report_value: 'ed_in_between',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Hospital Census',
            value:  'overall_census_calc',
            report_value: 'overall_census_calc',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Productivity Percentage',
            value:  'productivity_percentage_calc',
            report_value: 'productivity_percentage_calc',
            type:   '',
            show: true,
            order: 0,
        },
    ],

    log_productivity_by_associate_table_headers: [
        {
            text:   'Associate',
            value:  'associate',
            report_value: 'associate',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Days Logged',
            value:  'days_logged',
            report_value: 'days_logged',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Time Available',
            value:  'minutes_available_calc',
            report_value: 'minutes_available_calc',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Discharge Capabilities',
            value:  'discharge_capability_calc',
            report_value: 'discharge_capability_calc',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Discharges Completed',
            value:  'discharge_beds_count',
            report_value: 'discharge_beds_count',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Overtime',
            value:  'over_time_minutes',
            report_value: 'over_time_minutes',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Project Minutes',
            value:  'project_time',
            report_value: 'project_time',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Other Minutes',
            value:  'other_assignments',
            report_value: 'other_assignments',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Assignment Census',
            value:  'assignment_census',
            report_value: 'assignment_census',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Productivity Percentage',
            value:  'productivity_percentage_calc',
            report_value: 'productivity_percentage_calc',
            type:   '',
            show: true,
            order: 0,
        },
    ],

    log_productivity_by_assignment_table_headers: [
        {
            text:   'Assignment Number',
            value:  'assignment_number',
            report_value: 'assignment_number',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Days Logged',
            value:  'days_logged',
            report_value: 'days_logged',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Time Available',
            value:  'minutes_available_calc',
            report_value: 'minutes_available_calc',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Discharge Capabilities',
            value:  'discharge_capability_calc',
            report_value: 'discharge_capability_calc',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Discharges Completed',
            value:  'discharge_beds_count',
            report_value: 'discharge_beds_count',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Overtime',
            value:  'over_time_minutes',
            report_value: 'over_time_minutes',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Project Minutes',
            value:  'project_time',
            report_value: 'project_time',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Other Minutes',
            value:  'other_assignments',
            report_value: 'other_assignments',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Assignment Census',
            value:  'assignment_census',
            report_value: 'assignment_census',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Productivity Percentage',
            value:  'productivity_percentage_calc',
            report_value: 'productivity_percentage_calc',
            type:   '',
            show: true,
            order: 0,
        },
    ],

}

export default Resources;